import { createContext } from "react";

const PopoverContentAlign = [
  "left-bottom",
  "right-bottom",
  "top-left",
  "top-right",
  "center-bottom",
  "top-center",
] as const;
export type PopoverContentAlign = (typeof PopoverContentAlign)[number];

export interface PopoverContextResponse {
  opened: boolean;
  handleToggle?: () => void;
}
export const PopoverContext = createContext<PopoverContextResponse>({
  opened: false,
});
